
<span class="PGTags {{!readonly ? 'PGTags--NotReadOnly' : ''}}">
    <span ngbDropdown [autoClose]="false" class="PGTags-Select">
        <div ngbDropdownAnchor class="input-group">
            <input #inputElement class="form-control PGTags-Value" placeholder="{{placeholder}}"
                [attr.id]="fieldId || null"
                [attr.aria-label]="placeholder || ('pg-tags.a11y.input' | locTranslate)"
                [readonly]="readonly" [ngModel]="value" (ngModelChange)="setValue($event);"
                (focus)="onInputFocus()" (focusout)="onInputBlur()" (keypress)="onKeyPress($event)"/>
            </div>
            <div ngbDropdownMenu class="dropdown-menu PGTags-Select-Dropdown {{isDropdownClosing ? 'pg-animation-fadeout' : 'pg-animation-fadein'}}">
                <span class="PGTags-Select-Dropdown-Options">
                    @if (isDropdownLoading) {
                        <app-pg-loading pgAnimations="FadeIn" [isOverlay]="true"></app-pg-loading>
                    }
                    <!-- NB: sulle options ho usato il mousedown come evento perché il click dava problemi "strani" -->

                    @if (options.length == 0) {
                        <div class="dropdown-item disabled">Nessun suggerimento</div>
                    }
                    @for (option of options; track option; let i = $index) {
                        <div class="dropdown-item {{isOptionSelected(option) ? 'active' : ''}}"
                            (mousedown)="selectOption(option)">
                            <span [innerHTML]="option.view != null ? option.view : option.value"></span>
                        </div>
                    }
                </span>
            </div>
        </span>
    </span>
